export default __webpack_public_path__ + "static/media/MDM.04028ce9.png";